@if (totalNotifications==0) {
  <div class="ontario-row ontario-margin-bottom-24-!">
    <app-alert-banner bannerType="alert" [bannerText]="'ClassEnrolment.NoNotificationsYet' | translate"></app-alert-banner>
  </div>
} @else {
  <div class="ontario-row notification-search-section">
    <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-left-0-! ontario-padding-right-0-!">
      <app-notifications-search (notificationSearchCriteriaChanged)="handleNotificationSearchCriteriaChanged($event)"></app-notifications-search>
    </div>
  </div>
  <div class="ontario-row">
    <div class="ontario-column ontario-small-12 ontario-medium-4 scrollable ontario-padding-left-0-!">
      @for (notificationGroup of notificationGroups; track notificationGroup; let i = $index) {
        <div>
          <h3 [class.first]="i == 0">{{getDate(notificationGroup.CreatedDate | utcToLocalDateTime, 'EEEE, MMMM dd, yyyy')}}</h3>
          @for (notification of notificationGroup.Notifications; track notification) {
            <div class="card" [ngClass]=" {'unread' : !notification.IsRead}"
              (click)="selectNotification(notification)">
              <h4>
                <span>{{currentLang == 'fr' ? notification.NotificationTitleFr : notification.NotificationTitle}}</span>
                <span class="time">{{notification.CreatedDate | utcToLocalDateTime: 'hh:mm a'}}</span>
              </h4>
              <div class="shorttext rich-text-render" [innerHTML]="trustHtml(notification.NotificationNote)"></div>
            </div>
          }
        </div>
      }
    </div>
    <div class="ontario-column ontario-small-12 ontario-medium-8">
      <app-notifications-item [selectedNotification]="selectedNotification"></app-notifications-item>
    </div>
  </div>
}
